import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Settings, Clock, FileText, ArrowRight, CheckCircle } from 'lucide-react';

const ServicesPreview = () => {
  const services = [
    {
      icon: Wrench,
      title: 'AC Installation & Repair',
      description: 'Professional installation and repair services for all types of AC units.',
      features: ['Split AC Systems', 'Window Units', 'Central Cooling'],
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Settings,
      title: 'Spare Parts Supply',
      description: 'High-quality, branded AC spare parts with fast delivery service.',
      features: ['Genuine Parts', 'Fast Delivery', 'All Major Brands'],
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: Clock,
      title: '24/7 Maintenance',
      description: 'Round-the-clock responsive technicians for emergency and routine maintenance.',
      features: ['Emergency Response', 'Scheduled Service', 'System Diagnostics'],
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FileText,
      title: 'AMC Services',
      description: 'Flexible Annual Maintenance Contracts with priority response and discounts.',
      features: ['Priority Service', 'Cost Savings', 'Extended Warranty'],
      color: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white rounded-full px-4 py-2 shadow-sm border border-gray-200 mb-6">
            <span className="text-gray-700 font-medium text-sm">Our Services</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive <span className="text-purple-600">HVAC Solutions</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional air conditioning and refrigeration services tailored to your specific needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200"
            >
              {/* Icon */}
              <div className={`bg-gradient-to-r ${service.color} w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <service.icon size={24} className="text-white" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              {/* Features */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-600 text-sm">
                    <CheckCircle size={14} className="text-green-500 mr-2 flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/services"
            className="group inline-flex items-center bg-gradient-to-r from-purple-600 to-blue-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-purple-700 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-xl"
          >
            <span>View All Services</span>
            <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;